import { EditWidget } from '@/components/edit-widget';
import { GridPanel } from '@/components/grid-panel';
import { Page } from '@/components/page';
import { Toggle } from '@/components/toggle';
import { VaultListWidget } from '@/features/vault/components/vault-list-widget';
import { useScreenId } from '@/hooks/use-screen-id';
import { useTabId } from '@/hooks/use-tab-id';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import GridLayout, { WidthProvider } from 'react-grid-layout';

const layout = [
  { i: 'main', x: 0, y: 0, w: 25, h: 20 },
  { i: 'main_right', x: 25, y: 0, w: 15, h: 20 },
];

const AutoWidthGridLayout = WidthProvider(GridLayout);

export function Vault() {
  const [isDraggable, setIsDraggable] = useState<boolean>(false);
  const tabId = useTabId();
  const screenId = useScreenId();
  const [searchParams] = useSearchParams();
  const dataClassUuid = searchParams.get('dataClassUuid') ?? undefined;
  const defaultUuid = searchParams.get('key') ?? undefined;
  const defaultApp = searchParams.get('app') ?? undefined;
  const defaultExtraParams = defaultApp ? { app: defaultApp } : undefined;
  const idPrefix = `${tabId}/${screenId}`;

  if (!tabId || !screenId) {
    return null;
  }

  return (
    <Page
      title="Vault"
      toolbar={
        <Toggle
          enabled={isDraggable}
          label="Enable drag"
          onChange={setIsDraggable}
        />
      }
    >
      <AutoWidthGridLayout
        className="layout"
        layout={layout}
        cols={40}
        rowHeight={30}
        isDraggable={isDraggable}
      >
        <GridPanel key="main">
          <VaultListWidget id={`${idPrefix}/vault`} showEdit={true} />
        </GridPanel>
        <GridPanel key="main_right">
          <EditWidget id={`${idPrefix}/edit`} type="vault" initalCreateDataClass={dataClassUuid} defaultUuid={defaultUuid} defaultExtraParams={defaultExtraParams} />
        </GridPanel>
      </AutoWidthGridLayout>
    </Page>
  );
}
